module.exports = __webpack_public_path__ + "img/17.9828c47a.png";